var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilePen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2H13.25V8C13.25 8.9665 14.0335 9.75 15 9.75H20.9992C20.9997 9.76904 21 9.78811 21 9.80721V10.8714C20.2691 10.555 19.3879 10.6955 18.7905 11.2929L12.988 17.0954C12.6612 17.4222 12.4024 17.8104 12.2265 18.2377L11.428 20.1769C11.1749 20.7915 11.2801 21.4895 11.6894 22H5C3.89543 22 3 21.1046 3 20V4C3 2.89543 3.89543 2 5 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 2H13.25V8C13.25 8.9665 14.0335 9.75 15 9.75H20.9992C20.9997 9.76904 21 9.78811 21 9.80721V10.8714C20.2691 10.555 19.3879 10.6955 18.7905 11.2929L12.988 17.0954C12.6612 17.4222 12.4024 17.8104 12.2265 18.2377L11.428 20.1769C11.1749 20.7915 11.2801 21.4895 11.6894 22H5C3.89543 22 3 21.1046 3 20V4C3 2.89543 3.89543 2 5 2Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8399 2.61172L20.2768 8.24999H15C14.8619 8.24999 14.75 8.13806 14.75 7.99999V2.52417C14.7808 2.55232 14.8108 2.58151 14.8399 2.61172Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8399 2.61172L20.2768 8.24999H15C14.8619 8.24999 14.75 8.13806 14.75 7.99999V2.52417C14.7808 2.55232 14.8108 2.58151 14.8399 2.61172Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1626 12.1724C20.3925 11.9425 20.7652 11.9425 20.9951 12.1724L21.8276 13.0049C22.0575 13.2348 22.0575 13.6075 21.8276 13.8374L21.0324 14.6326L19.3674 12.9676L20.1626 12.1724Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.789 15.8761L18.124 14.2111L14.0852 18.2498C13.9753 18.3598 13.8883 18.4904 13.8291 18.6341L13.0222 20.5937C12.9769 20.7036 13.0022 20.8299 13.0862 20.9139C13.1702 20.9979 13.2965 21.0232 13.4064 20.9779L15.366 20.171C15.5097 20.1118 15.6403 20.0248 15.7503 19.9149L19.789 15.8761Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePen);
export default __webpack_public_path__ + "static/media/file-pen.148e02b8fbfd3c951ac7c524fef60133.svg";
export { ForwardRef as ReactComponent };